import NavBar from "../generalComponents/NavBar";
import JobForm from "./components/JobForm";
import {Link, useParams} from "react-router-dom";
import Button1 from "../UI/Button1";
import {useEffect, useState} from "react";
import JobFormNew from "./JobFormNew";

const JobFormPage = () => {

    const { lang, id } = useParams();
    let currentID;

    useEffect(() => {

        if(currentID === null){
            currentID = id;
        }

        // options: en , de
        console.log("Language is ", lang);
        console.log("ID is ", id);

    }, [lang]);

    return(
        <div>
            <NavBar></NavBar>
            <div>
                <JobFormNew key={lang}></JobFormNew>
            </div>
        </div>
    );
}

export default JobFormPage;